import { render, staticRenderFns } from "./Node.vue?vue&type=template&id=31ca1c24&scoped=true"
import script from "./Node.vue?vue&type=script&lang=js"
export * from "./Node.vue?vue&type=script&lang=js"
import style0 from "./Node.vue?vue&type=style&index=0&id=31ca1c24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ca1c24",
  null
  
)

export default component.exports